import flatten from 'lodash/flatten'

import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { SettingId, getSettingsItemsData } from 'modules/settings/lib/settings/data'

export type SettingPageMetaProps = {
  title: string
  description?: string
}

export const getSettingPageMeta: (
  navigation: Navigation<NavigationPaths>,
  settingId: SettingId
) => SettingPageMetaProps | undefined = (navigation, settingId) => {
  const settings = getSettingsItemsData({
    navigation,
  })

  const item = flatten(settings.map((setting) => [setting, ...setting.children])).find(
    (setting) => setting.id === settingId
  )

  if (!item) return

  return {
    title: item.title,
    description: 'description' in item ? item.description : undefined,
  }
}
